import { render, staticRenderFns } from "./OpenSanadBtn.vue?vue&type=template&id=4da13b32&"
import script from "./OpenSanadBtn.vue?vue&type=script&lang=js&"
export * from "./OpenSanadBtn.vue?vue&type=script&lang=js&"
import style0 from "./OpenSanadBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
